import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { settingCss } from 'styles/intro/common';

export function CustomImage({ src, alt, ...props }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (src) {
      setLoading(false);
    }
    return () => setLoading(true);
  }, [src]);

  return <ImageStyle src={src} alt={alt} $filter={(loading && 'blur(10px)') || 'blur(0px)'} {...props} />;
}

const ImageStyle = styled.img`
  display: block;
  transition: all 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
  ${settingCss};
  ${({ objectFit }) => objectFit && `object-fit: ${objectFit};`};
  ${({ objectPosition }) => objectPosition && `object-position: ${objectPosition};`};
  ${({ $filter }) => $filter && `filter:${$filter}`};
`;
